import { twoFactorAuthSlice } from './two-factor-auth';

export const {
    show2faRequirePopup,
    hide2faRequirePopup,
    show2faPostPurchasePopup,
    hide2faPostPurchasePopup,
    show2faSetupFlow,
    hide2faSetupFlow,
    show2faExpiredLogin,
    hide2faExpiredLogin,
    set2faResetCode,
    toggle2faMintingPopup,
    toggle2faArtifactMintingPopup,
} = twoFactorAuthSlice.actions;
export const { reducer: twoFactorAuthReducer } = twoFactorAuthSlice;

export type { TwoFactorAuthState } from './types';
